export enum EAddressType {
  Physical,
  Mailing,
}
